module.exports = __webpack_public_path__ + "static/media/soul-learn-baner-bg.ccd55024.svg";